import styled from 'styled-components'
import cross from '../../assets/addStockModal/pages/cross.svg'
import check from '../../assets/addStockModal/pages/check.svg'
import arrowDown from '../../assets/certificates/AddParameter/arrow-down.svg'

export const Container = styled.div`
    position: absolute;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 1vw;
    z-index: 9004;
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2vw;
    cursor: pointer;
    width: 2.5vw;
    height: 2.5vw;

    :hover{
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 0.8vw;
`

export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 2.8vh;
    margin-left: 1.5vw;
    margin-right: 1vw;
`

export const HeaderText = styled.h2`
    font-family: 'Inter', sans-serif;
    font-size: 1.4vw;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 0;
`

export const NextButtonDiv = styled.div`
    display: flex;
    align-items: center;
    width: 8vw;
    height: 5.8vh;
    background-color: #0090D3;
    color: #fff;
    border-radius: 3vw;
    cursor: pointer;
`

export const NextButtonImage = styled.img`
    margin-left: 1.7vw;   
    width: 0.9vw;
`

export const NextButtonText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 1vw;
    font-weight: 700;
    margin-left: 0.6vw;
`

export const ButtonsDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 12px;
    padding: 0 1.5vw;

    .disabled {
        background-color: #696969;
        pointer-events: none;
    }
`

export const WarningDiv = styled.div`
    position: absolute;
    display: flex;
    width: 58vw;
    justify-content: end;
    right: 1vw;
    bottom: 7.5vh;
`

export const WarningText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 0.8vw;
    color: #FF0000;
`


export const InputRowDiv = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 2.5vh;
    padding: 0 1.5vw;
    justify-content: space-between;
`

export const InputDiv = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;

    .redBorder {
        border: #FF0000 1px solid;
    }

    .empty {
        border: 0;
    }
`

export const InputDivText = styled.div`
    position: relative;
    margin-top: 1vw;
    

    .redBorder {
        border: #FF0000 1px solid;
    }
`

export const InputLabel = styled.label`
    display: block;
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 0.9vw;
`
export const InputLabel2 = styled.label`
    display: block;
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 0.9vw;
    margin-left: 1.5vw;
    margin-right: 16vw;
`

export const InputLabel3 = styled.label`
    display: block;
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 0.9vw;
    margin-left: 1.5vw;
    margin-right: 15vw;
`


export const Input = styled.input`
    width: 15.5vw;
    height: 5.3vh;
    background-color: #EBEBEB;
    border: 0;
    border-radius: 2vw;
    padding-left: 1vw;
    padding-right: 1vw;

    :focus {
        outline: 0;
    }
`
export const Input2 = styled.input`
    width: 15.5vw;
    height: 5.3vh;
    background-color: #EBEBEB;
    border: 0;
    border-radius: 2vw;
    margin-top: 0.8vh;
    margin-left: 1vw;
    margin-right: 4.5vw;
    padding-left: 1vw;
    padding-right: 1vw;

    :focus {
        outline: 0;
    }
`

export const InputText = styled.textarea`
    width: 25vw;
    height: 8vw;
    background-color: #EBEBEB;
    border: 0;
    border-radius: 2vw;
    margin-top: 0.8vh;
    padding-left: 1vw;
    padding-right: 1vw;
    resize: none; 

    :focus {
        outline: 0;
    }
`;


export const SelectInputMoviment = styled.select`
    width: 10vw;
    height: 5.3vh;
    background-color: #EBEBEB;
    border: 0;
    border-radius: 2vw;
    padding-left: 1vw;
    padding-right: 1vw;
    cursor: pointer;
    background-image: url(${arrowDown});
    background-repeat: no-repeat;
    background-position-x: 7vw;
    background-position-y: 1.6vh;
    background-size: 18px 15px;


    -webkit-appearance: none;
    appearance: none;

    :focus {
        outline: 0;
    }
`

export const SelectInputKgOrMm = styled.select`
    width: 10vw;
    height: 5.3vh;
    background-color: #EBEBEB;
    border: 0;
    border-radius: 2vw;
    padding-left: 1vw;
    padding-right: 1vw;
    cursor: pointer;
    background-image: url(${arrowDown});
    background-repeat: no-repeat;
    background-position-x: 7vw;
    background-position-y: 1.6vh;
    background-size: 18px 15px;


    -webkit-appearance: none;
    appearance: none;

    :focus {
        outline: 0;
    }
`

export const SelectOption = styled.option`
    width: 15.5vw;
    height: 5.3vh;
    background-color: #EBEBEB;
    border: 0;
    margin-top: 0.8vh;
    padding-left: 1vw;
    padding-right: 1vw;

`

export const SwitchesDiv = styled.div`
    display: grid;
    grid-template-columns: repeat(2 , 1fr);
    padding: 0 1.5vw;
    margin-top: 3vh;
    align-items: center;
    justify-content: space-between;
`

export const SwitchDiv = styled.div`
    display: flex;
    flex-direction: column;
`

export const SwitchLabel = styled.label`
    font-weight: 700;
    font-size: 0.9vw;
    font-family: 'Inter', sans-serif;
`

export const SwitchBox = styled.label`
    display: inline-block;
    position: relative;
    margin-top: 1vh;
    width: 60px;
    height: 34px;
`

export const SwitchInput = styled.input`
    opacity: 0;
    width: 0;
    height: 0;

    :checked + .slider {
        background-color: #2196F3;
        border: 0;
        padding: 2px;
    }

    :focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }

    :checked + .slider:before {
        background-image: url(${check});
        background-repeat: no-repeat;
        background-position: center;
        background-size: 15px 15px;
        background-color: #fff;
        -webkit-transform: translateX(24px);
        -ms-transform: translateX(24px);
        transform: translateX(24px);
    }
`

export const SwitchSlider = styled.span`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 34px;
    border: #696969 2px solid;

    :before {
        display: block;
        position: relative;
        content: "";
        height: 24px;
        width: 24px;
        left: 5.5px;
        top: 2.8px;
        background-color: #696969;
        border-radius: 50%;
        transition: all 0.4s;
        background-image: url(${cross});
        background-repeat: no-repeat;
        background-position: center;
        background-size: 11px 11px;
    }
`

export const PreviousButtonDiv = styled.div`
    display: flex;
    align-items: center;
    width: 6.5vw;
    height: 5.8vh;
    background-color: #fff;
    color: #0090D3;
    border: solid #0090D3 1px;
    margin-top: 2.5vh;
    margin-bottom: 2.5vh;
    margin-left: 1vw;
    border-radius: 3vw;
    cursor: pointer;
`

export const PreviousButtonImage = styled.img`
    margin-left: 1vw;   
    width: 0.9vw;
`

export const PreviousButtonText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 1vw;
    font-weight: 700;
    margin-left: 0.6vw;
`